const PRODUCT_STATUS = {
  UNAVAILABLE: ["UNAVAILABLE"],
  RETURN_CONFIRMED: ["RETURN_DONE"],
  RETURN_PENDING: ["TO_RETURN"],
};

export { PRODUCT_STATUS };
